export interface LegacyLinkFlags {
  isExternal?: boolean
  neverMigrate?: boolean
}

/**
 * A sidebar link is "legacy" while its page still lives in the old admin (app-main).
 * In app-admin that means an external link, unless explicitly opted out of migration.
 */
export const isLegacyLink = ({ isExternal, neverMigrate }: LegacyLinkFlags): boolean =>
  Boolean(isExternal) && !neverMigrate
